import { API } from "@/lib/api";

const TAG = /\[\[document[^\]]*\]\]?/g;
const SENTENCE = /^([\s\S]*?[.!?])(\s+)/;

async function fetchAudio(voiceToken, text) {
  const res = await fetch(`${API}/voice/speak`, {
    method: "POST", credentials: "include", headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ voice_token: voiceToken, text }),
  });
  if (!res.ok) return null;
  return URL.createObjectURL(await res.blob());
}

function playUrl(url, audioRef) {
  if (!url) return Promise.resolve();
  const audio = new Audio(url);
  audioRef.current = audio;
  return new Promise((r) => { audio.onended = r; audio.onpause = r; audio.play().catch(r); });
}

// Speaks a streaming reply sentence by sentence, fetching each clip as soon as the sentence is complete.
export function createSpeaker(voiceToken, audioRef, stopRef, onStart) {
  let buf = "", chain = Promise.resolve(), count = 0;
  const enqueue = (text) => {
    const clean = text.replace(TAG, "").trim();
    if (!clean || stopRef.current) return;
    count += 1;
    const clip = fetchAudio(voiceToken, clean);
    chain = chain.then(async () => {
      const url = await clip;
      if (stopRef.current) return;
      if (url) onStart();
      await playUrl(url, audioRef);
    });
  };
  return {
    push(delta) {
      buf += delta;
      let m;
      while ((m = SENTENCE.exec(buf)) && m[1].trim().length >= 12) {
        enqueue(m[1]);
        buf = buf.slice(m[0].length);
      }
    },
    async finish() {
      enqueue(buf);
      buf = "";
      await chain;
      return count > 0;
    },
  };
}
